import type { TreatmentPlanV3PlanAction, TreatmentPlanV3State } from '../../../types';

export function isForLoadedAssessmentPage(
  state: TreatmentPlanV3State,
  action: TreatmentPlanV3PlanAction,
) {
  return action.meta.arg.treatmentPlanId === state.assessmentPageTreatmentPlanId;
}

export function isForLoadedAssessmentTemplates(
  state: TreatmentPlanV3State,
  action: TreatmentPlanV3PlanAction,
) {
  return action.meta.arg.treatmentPlanId === state.assessmentTemplatesTreatmentPlanId;
}

export function markAssessmentPageChanged(state: TreatmentPlanV3State) {
  if (state.assessmentPageLoading) {
    state.assessmentPageChangedSinceRequest = true;
  }
}
